import { NotificationsTranslations } from '@/assets/locales/components/notifications/notifications.translations.en.ts';

export const notificationsTranslations: NotificationsTranslations = {
  goToMySurveys: 'Moje certyfikacje',
  goToSurvey: 'Przejdź do ankiety',
  markAsRead: 'Oznacz jako przeczytane',
  markAsUnread: 'Oznacz jako nieprzeczytane',
  unread: 'Nieprzeczytane',
  viewProfile: 'Zobacz profil odbiorcy',
};
